"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuccessFlash = exports.LoadingFlash = exports.ErrorFlash = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _grid = require("../../layouts/grid");
var _typography = require("../../typography");
var _loading_spinner = _interopRequireDefault(require("../loading_spinner"));
var _timed_fade = _interopRequireDefault(require("../../animations/timed_fade"));
var _theme = _interopRequireDefault(require("./theme"));
var _check = _interopRequireDefault(require("../../icons/check"));
var _error = _interopRequireDefault(require("../../icons/error"));
var _compact_row = require("../../layouts/compact_row");
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TIME_VISIBLE_IN_MILLISECONDS = 8000;
var Flash = function Flash(props) {
  var icon = props.icon,
    backgroundColor = props.backgroundColor,
    message = props.message;
  return /*#__PURE__*/React.createElement(_timed_fade["default"], (0, _extends2["default"])({
    showMilliseconds: TIME_VISIBLE_IN_MILLISECONDS
  }, (0, _constants.getDataProvidesProps)(props)), /*#__PURE__*/React.createElement(WidthConstraint, null, /*#__PURE__*/React.createElement(_grid.Grid, {
    container: true,
    spacing: 2,
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(FlashContents, {
    "data-provides": "flash-content-wrapper",
    backgroundColor: backgroundColor
  }, /*#__PURE__*/React.createElement(_compact_row.CompactRow, {
    spacing: 2,
    wrap: "nowrap",
    alignItems: "flex-start"
  }, /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(IconContainer, null, icon)), /*#__PURE__*/React.createElement(_grid.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/React.createElement(_typography.Body, {
    "data-provides": "flash-message"
  }, message)))))));
};
var SuccessFlash = function SuccessFlash(props) {
  var message = props.message;
  return /*#__PURE__*/React.createElement(Flash, (0, _extends2["default"])({
    icon: /*#__PURE__*/React.createElement(_check["default"], {
      color: _theme["default"].success.iconColor
    }),
    backgroundColor: _theme["default"].success.backgroundColor,
    message: message
  }, (0, _constants.getDataProvidesProps)(props)));
};
exports.SuccessFlash = SuccessFlash;
SuccessFlash.displayName = 'SuccessFlash';
var ErrorFlash = function ErrorFlash(props) {
  var message = props.message;
  return /*#__PURE__*/React.createElement(Flash, (0, _extends2["default"])({
    icon: /*#__PURE__*/React.createElement(_error["default"], {
      color: _theme["default"].error.iconColor
    }),
    backgroundColor: _theme["default"].error.backgroundColor,
    message: message
  }, (0, _constants.getDataProvidesProps)(props)));
};
exports.ErrorFlash = ErrorFlash;
ErrorFlash.displayName = 'ErrorFlash';
var LoadingFlash = function LoadingFlash(props) {
  var message = props.message;
  return /*#__PURE__*/React.createElement(Flash, (0, _extends2["default"])({
    icon: /*#__PURE__*/React.createElement(_loading_spinner["default"], {
      size: "small"
    }),
    backgroundColor: _theme["default"].loading.backgroundColor,
    message: message
  }, (0, _constants.getDataProvidesProps)(props)));
};
exports.LoadingFlash = LoadingFlash;
LoadingFlash.displayName = 'LoadingFlash';
var WidthConstraint = _styledComponents["default"].div.withConfig({
  displayName: "flash__WidthConstraint"
})(["margin:auto;max-width:min(80vw,800px);"]);
var FlashContents = _styledComponents["default"].div.withConfig({
  displayName: "flash__FlashContents"
})(["", " padding:12px 16px;display:inline-block;box-shadow:0 2px 6px rgba(0,0,0,0.13);border-radius:5px;"], function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return "background: ".concat(backgroundColor, ";");
});
var IconContainer = _styledComponents["default"].span.withConfig({
  displayName: "flash__IconContainer"
})(["svg{top:0.125em;position:relative;}"]);